// Payment labels shared by the reconciliation modal and its manual payment form.
// Method labels match the backend PAYMENT_METHOD_LABELS (expenseManualPayments.js).
export const PAYMENT_METHODS = ['PayPal', 'Lydia', 'Espèces', 'Virement', 'Carte', 'Autre'];

export const PAYMENT_TYPE_LABELS = { tattoo: 'Tattoo', deposit: 'Acompte', commission: 'Commission' };

// Types a manually added payment can take; they share the reservation invoice series.
export const MANUAL_PAYMENT_TYPES = ['tattoo', 'deposit'];

export const DEFAULT_MANUAL_PAYMENT_METHOD = 'Carte';
